export default [{
        path: "/ventas/presupuesto",
        name: "ventas-presupuesto",
        component: () =>
            import ("@/views/pages/ventas/transacciones/Presupuesto.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-presupuesto',
            pageTitle: "Presupuesto",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Transacciones" },
                { text: "Presupuesto", active: true }
            ]
        }
    }, {
        path: "/ventas/configuracion/proyeccion",
        name: "ventas-configuracion-proyeccion",
        component: () =>
            import ("@/views/pages/ventas/configuracion/ConfiguracionProyeccion.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-configuracion-proyeccion',
            pageTitle: "Configuracion Presupuesto",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Configuracion" },
                { text: "Presupuesto", active: true }
            ]
        }
    }, {
        path: "/ventas/dashboard/proyeccion",
        name: "ventas-dashboard-proyeccion",
        component: () =>
            import ("@/views/pages/ventas/dashboard/DashBoardProyeccion.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-dashboard-proyeccion',
            pageTitle: "Proyeccion",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Dashboard" },
                { text: "Proyeccion", active: true }
            ]
        }
    }, {
        path: "/ventas/informes/presupuesto",
        name: "ventas-reporte-presupuesto",
        component: () =>
            import ("@/views/pages/ventas/informes/ReportePresupuesto.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-reporte-presupuesto',
            pageTitle: "Reporte Presupuesto",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Informes" },
                { text: "Reporte Presupuesto", active: true }
            ]
        }
    },
    {
        path: "/ventas/informes/cierre-mes",
        name: "ventas-reporte-cierre-mes",
        component: () =>
            import ("@/views/pages/ventas/informes/ReporteCierreMes.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-reporte-cierre-mes',
            pageTitle: "Reporte Cierre de Mes",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Informes" },
                { text: "Reporte Cierre de Mes", active: true }
            ]
        }
    },
    {
        path: "/ventas/transacciones/solicitud-presupuesto",
        name: "ventas-solicitud-presupuesto",
        component: () =>
            import ("@/views/pages/ventas/transacciones/SolicitudPresupuesto.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-solicitud-presupuesto',
            pageTitle: "Solicitud de Presupuesto",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Transacciones" },
                { text: "Solicitud de Presupuesto", active: true }
            ]
        }
    },
    {
        path: "/ventas/transacciones/aprobacion-solicitud",
        name: "ventas-aprobacion-presupuesto",
        component: () =>
            import ("@/views/pages/ventas/transacciones/AprobacionSolicitud.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-aprobacion-presupuesto',
            pageTitle: "Aprobacion de Solicitud de Presupuesto",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Transacciones" },
                { text: "Aprobacion de Solicitud de Presupuesto", active: true }
            ]
        }
    },
    {
        path: "/ventas/transacciones/pedido-cliente-muestra",
        name: "ventas-pedido-muestras",
        component: () =>
            import ("@/views/pages/ventas/transacciones/PedidoMuestras.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-pedido-muestras',
            pageTitle: "Pedido de Cliente de Muestras",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Transacciones" },
                { text: "Pedido de Cliente de Muestras", active: true }
            ]
        }
    },
    {
        path: "/ventas/informes/proyecciones",
        name: "ventas-reporte-proyecciones",
        component: () =>
            import ("@/views/pages/ventas/informes/ReporteProyeccion.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-reporte-proyecciones',
            pageTitle: "Proyecciones",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Informes" },
                { text: "Proyecciones", active: true }
            ]
        }
    },
    {
        path: "/ventas/informes/proyeccionesAnio",
        name: "ventas-reporte-proyecciones-anio",
        component: () =>
            import ("@/views/pages/ventas/informes/ReporteProyeccionAnio.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-reporte-proyecciones-anio',
            pageTitle: "Proyecciones",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Informes" },
                { text: "Proyecciones Por Año", active: true }
            ]
        }
    }
    , {
        path: "/ventas/dashboard/promociones",
        name: "ventas-dashboard-promociones",
        component: () =>
            import ("@/views/pages/ventas/dashboard/AprobacionPromociones.vue"),
        meta: {
			title: 'i18n:',
            resource: 'Ventas',
            action: 'ver-ventas-dashboard-promociones',
            pageTitle: "Aprobacion Promociones",
            breadcrumb: [
                { text: "Ventas" },
                { text: "Dashboard" },
                { text: "Aprobacion Promociones", active: true }
            ]
        }
    }
]
